import { useMemo } from 'react';

import useComponentLazyLoad from 'hooks/useComponentLazyLoad';
import Image from 'components/Image';
import type { EmbeddedVideoProps } from '../types';

import useStyles from './styles';

const youtubeEmbedUrl = 'https://www.youtube-nocookie.com/embed';

const YoutubeVideo = (props: EmbeddedVideoProps) => {
  const classes = useStyles();
  const { videoLink, autoPlay, allowControls, skipSuggestions } = props;
  const videoSearchParams = videoLink.split('?')[1];
  const urlParams = new URLSearchParams(videoSearchParams);
  const videoId = urlParams.get('v');
  const { isInViewport, elementRef } = useComponentLazyLoad();

  const videoThumb = `https://img.youtube.com/vi/${videoId}/0.jpg`;

  const video = useMemo(() => {
    return `${youtubeEmbedUrl}/${videoId}?playlist=${videoId}&loop=${Number(
      skipSuggestions,
    )}&autoplay=${Number(autoPlay)}&mute=${Number(autoPlay)}&controls=${
      Number(allowControls) || 0
    }`;
  }, [videoId, skipSuggestions, autoPlay, allowControls]);

  return (
    <div ref={elementRef}>
      {isInViewport ? (
        <iframe
          className={classes.iframe}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture, autoplay"
          src={video}
          title="YouTube video player"
          allowFullScreen={false}
          frameBorder="0"
          loading="lazy"
        />
      ) : (
        <Image className={classes.iframe} src={videoThumb} alt="youtube video thumbnail" />
      )}
    </div>
  );
};

export default YoutubeVideo;
